export default __webpack_public_path__ + "static/media/press-16.69f10259.jpg";